// extracted by mini-css-extract-plugin
export var container = "_so-0";
export var table = "_so-2";
export var tableWrapper = "_so-1";